/**
 * Accessing values through the function prevents the compiler from optimizing them away as constants.
 */
function getEnvVariable(envName: string): string {
  if (import.meta.env.VITE_DOCKER_BUILDING_PROCESS === 'true') {
    // When Docker is building the function returns env key (placeholder).
    // Placeholders are replaced with actual values during Docker startup via `entrypoint.sh`.
    return envName
  }

  return import.meta.env[envName]
}

export const ENV_CONFIG = {
  LOCAL_ENVIRONMENT: !!getEnvVariable('NEXT_PUBLIC_ENGINE_API_URI').startsWith(
    'http://localhost',
  ),
  BASE_URI: getEnvVariable('NEXT_PUBLIC_BASE_URI'),
  ENGINE_API_URI: getEnvVariable('NEXT_PUBLIC_ENGINE_API_URI'),
  ENGINE_UI_URI: getEnvVariable('NEXT_PUBLIC_ENGINE_UI_URI'),
  PROD_ENGINE_API_URI: getEnvVariable('NEXT_PUBLIC_PROD_ENGINE_API_URI'),
  AUTH0_DOMAIN: getEnvVariable('NEXT_PUBLIC_AUTH0_DOMAIN'),
  AUTH0_CLIENT_ID: getEnvVariable('NEXT_PUBLIC_AUTH0_CLIENT_ID'),
  AUTH0_CLIENT_ID_PROD: getEnvVariable('NEXT_PUBLIC_AUTH0_CLIENT_ID_PROD'),
  ALGOLIA_APP_ID: getEnvVariable('NEXT_PUBLIC_ALGOLIA_APP_ID'),
  ALGOLIA_API_KEY: getEnvVariable('NEXT_PUBLIC_ALGOLIA_API_KEY'),
  ENABLE_TRACKING: getEnvVariable('NEXT_PUBLIC_ENABLE_TRACKING'),
  USE_CONNECTOR_STORE: getEnvVariable('NEXT_PUBLIC_USE_CONNECTOR_STORE'),
  CONNECTOR_BUILDER_LOCAL_MODE: getEnvVariable(
    'NEXT_PUBLIC_CONNECTOR_BUILDER_LOCAL_MODE',
  ),
  PYLON_APP_ID: getEnvVariable('NEXT_PUBLIC_PYLON_APP_ID'),
  ENABLE_LIMITS: getEnvVariable('NEXT_PUBLIC_ENABLE_LIMITS'),
  POSTHOG_KEY: getEnvVariable('NEXT_PUBLIC_POSTHOG_KEY'),
  POSTHOG_HOST: getEnvVariable('NEXT_PUBLIC_POSTHOG_HOST'),
  NODE_ENV: getEnvVariable('NODE_ENV'),
  ENABLE_USAGE_ALERTS:
    getEnvVariable('NEXT_PUBLIC_ENABLE_USAGE_ALERTS') === 'true',
  ENABLE_BILLING: getEnvVariable('NEXT_PUBLIC_ENABLE_BILLING'),
  IS_CLOUD: getEnvVariable('NEXT_PUBLIC_IS_CLOUD') === 'true',
}
